var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingCirclePill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E4D3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1287_4161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 8.00008C12.6665 7.63189 12.368 7.33341 11.9998 7.33341C11.6316 7.33341 11.3332 7.63189 11.3332 8.00008V12.0001C11.3332 12.2526 11.4758 12.4834 11.7017 12.5964L14.3684 13.9297C14.6977 14.0944 15.0981 13.9609 15.2628 13.6316C15.4274 13.3022 15.294 12.9018 14.9646 12.7371L12.6665 11.5881V8.00008Z",
    fill: "#621CCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 4.66675C7.94975 4.66675 4.6665 7.94999 4.6665 12.0001C4.6665 16.0502 7.94975 19.3334 11.9998 19.3334C16.0499 19.3334 19.3332 16.0502 19.3332 12.0001C19.3332 7.94999 16.0499 4.66675 11.9998 4.66675ZM5.99984 12.0001C5.99984 8.68637 8.68613 6.00008 11.9998 6.00008C15.3135 6.00008 17.9998 8.68637 17.9998 12.0001C17.9998 15.3138 15.3135 18.0001 11.9998 18.0001C8.68613 18.0001 5.99984 15.3138 5.99984 12.0001Z",
    fill: "#621CCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1287_4161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCirclePill);
export default __webpack_public_path__ + "static/media/PendingCirclePill.59d0775f4651e66567d407bf42b35609.svg";
export { ForwardRef as ReactComponent };